import { createSelector } from '@ngrx/store';

import { adapter } from './dab-history.reducer';
import { selectDabRootState } from './reducer';

/**
 * Feature selector
 */
export const selectDabHistoryState = createSelector(
  selectDabRootState,
  (state) => state.dabHistory,
);

export const { selectAll: selectDabHistory } = adapter.getSelectors(
  selectDabHistoryState,
);
